import type { NestedFilterKeys } from '@dresscode-frontend/utility-types';
import type { ColumnDef } from '@tanstack/table-core';

import { DataTableColumnHeader } from '@/components/DataTable/Columns/DataTableColumnHeader';
import type { HelperOptions } from '@/components/DataTable/types';
import { LastActivityCell } from '@/features/app-user/components/LastActivityCell';

type LastActivityDateColumnOptions<TData> = HelperOptions & {
  activeAccessorFn: (row: TData) => boolean;
};

/** 連携したアプリからDressCodeが取得したAppUserの最終操作(主にログイン)日時を表示するカラムコンポーネント */
export function AppUserLastActivityColumn<TData>(
  // ISO8601形式のstringであるため、stringを指定している。
  accessorKey: NestedFilterKeys<TData, string>,
  options: LastActivityDateColumnOptions<TData>,
): ColumnDef<TData> {
  const { minWidth = '200px', activeAccessorFn } = options;

  return {
    accessorKey,
    meta: { i18nKey: 'lastActivity' as const, thStyle: { minWidth } },
    header: (props) => <DataTableColumnHeader {...props} />,
    cell: ({ row, getValue }) => {
      const date = getValue<Date | null>();
      const isActive = activeAccessorFn(row.original);
      return <LastActivityCell date={date} isActive={isActive} />;
    },
  };
}
